module.exports = __webpack_public_path__ + "static/media/Penguins7049.3ff386bd.jpg";